import React from "react";
import CTable from "components/common/Table";
import Text from "components/common/Text";
import StarIcon from "@mui/icons-material/Star";
const FeedbackSuccessfulTable = ({
  data,
  loading,
  toggleDrawer,
  page,
  limit,
  totalCount,
  successful,
  isLoading,
  onPageChange
}) => {
  const columns = [
    {
      field: "customer_name",
      headerName: "Customer Name",
    },
    {
      field: "charging_station_name",
      headerName: "Charging Station",
    },
    {
      field: "charging_network",
      headerName: "Name of Network",
    },
    {
      field: "feedback",
      headerName: "Review",
      valueGetter: (v,d)=>{
        return <p style={{width:'170px'}}>{d?.feedback}</p>
      }
       },
    {
      field: "rating",
      headerName: "Rating",
      valueGetter: (v, d) => {
        const rating = d?.rating;

        const stars = [];
        for (let i = 0; i < rating; i++) {
          stars.push(
            <StarIcon
              key={i}
              sx={{
                fontSize: "20px",
                color: "#F8C301",
                marginRight: "5px",
              }}
            />
          );
        }

        return (
          <div style={{ display: "flex", justifyContent: "center" }}>
            {stars}
          </div>
        );
      },
    },

    {
      field: "date",
      headerName: "Date",
    },
    {
      field: "time",
      headerName: "Charging Time",
    },
    {
      field: "units_charged",
      headerName: "Unit Charged",
    },
    {
      field: "amount",
      headerName: "Amount",
    },
    // {
    //   field: "counter",
    //   headerName: "Country",
    // },
    {
      field: "reply",
      headerName: "Reply to Feedback",
      valueGetter: (v, d) => {
        return (
          <>
            {
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Text style={{ fontSize: "15px" }}>Reply</Text>

                <img
                  onClick={() =>
                    toggleDrawer({
                      id: d.id,
                      review: d.feedback,
                      customerName: d.customer_name,
                      date: d.date,
                      time: d.time,
                      reply_to_feedback:d.reply_to_feedback,
                      replyTime:d.updated_at
                    })
                  }
                  src="../images/replyicon.svg"
                  alt="reply"
                  style={{ width: "27px" }}
                ></img>
              </div>
            }
          </>
        );
      },
    },
  ];

  return (
    <CTable
      columns={columns}
      data={data ?? []}
      isLoading={isLoading}
      pagination={true}
      // localPagination={true}
      // page={0}
      // rowsPerPage={5}
      page={page}
      rowsPerPage={limit}
      count={totalCount}
      onPageChange={onPageChange}
    />
  );
};

export default FeedbackSuccessfulTable;
